// extracted by mini-css-extract-plugin
export default {"container":"NewsAboutUs_container__N-SxS","news":"NewsAboutUs_news__XJn0s","title":"NewsAboutUs_title__qCZhd","button":"NewsAboutUs_button__lSkak"};